var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2939b64f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/autosize-textarea.vue
// module id = null
// module chunks = 